//import {Validar} from "../../validar-egresos";
import { endpoints } from "./endpoints";
import axios from "axios";

const BASEURL = process.env.VUE_APP_API_SERVEL;

const getAll = async (filters) => {
    const url = `${BASEURL}${endpoints.vocales}`
    return axios.get(url,{params:filters}).then(response => {
        return response.data.data;
    });
}

const getById = async (filters) => {
    const url = `${BASEURL}${endpoints.vocales}/${filters.id}`
    return axios.get(url).then(response => {
        return response.data.data;
    });
}

const getElecciones = async (payload) => {
  try {
    const url = `${BASEURL}${endpoints.elecciones}`;
    return axios.get(url).then(response => {
      // Mapeo los nombres de los campos retornados por el backend a los nombres utilizados en el frontend
      return response.data.data;

    });
  } catch (error) {
    throw error;
  }
};

const send = async (data) => {

    try {

    const url = `${BASEURL}${endpoints.vocales}/editar`
    return axios.post(url,{data:data}).then(response => {
       return response.data;
    });
    } catch (error) {
        throw error
    }

}

const crear = async (data) => {

  try {

    const url = `${BASEURL}${endpoints.vocales}/crear`
    return axios.post(url,data).then(response => {
      return response.data;
    });
  } catch (error) {
    throw error
  }

}

const marcarCola = async (data) => {

  try {

    const url = `${BASEURL}${endpoints.vocales}/marcar`
    return axios.post(url,data).then(response => {
      return response.data;
    });
  } catch (error) {
    throw error
  }

}

const chargeFile = async (data) => {
    try {
        const url = `${BASEURL}${endpoints.vocales}/cargar`;
        const response = await axios.post(url, data);

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error('Respuesta vacía del servidor');
        }
    } catch (error) {
        console.error('Error en chargeFile:', error);
        // Añadir información adicional para depuración
        if (error.response) {
            // El servidor respondió con un código de estado fuera del rango 2xx
            throw new Error("Error del servidor: ".concat(error.response.status, " - ").concat(error.response.data && error.response.data.message ? error.response.data.message : JSON.stringify(error.response.data)));
        } else if (error.request) {
            // La solicitud fue hecha pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Error al configurar la solicitud
            throw error;
        }
    }
}

const getEstadisticas = async (params) => {
  try {
    const url = `${BASEURL}${endpoints.vocales}/dashboard/totales`;
    return axios.get(url, { params }).then(response => {
      // Mapeo los nombres de los campos retornados por el backend a los nombres utilizados en el frontend
      const data = response.data.data;
      return data
    });
  } catch (error) {
    throw error;
  }
};

export const PagoVocalesService = {
    getAll,
    getById,
    chargeFile,
    send,
    crear,
    marcarCola,
    getEstadisticas,
    getElecciones
    // exportTeacherListExcel
}
